import { DelayedSpinner } from "@digipost/dds-spinner-react";
import { createContext, FC, PropsWithChildren, useContext } from "react";
import { useLoaderData } from "react-router";

import { DigipostEntryPoint } from "../../types/entrypoint";

const EntrypointContext = createContext<DigipostEntryPoint | null>(null);

export const useEntrypointContext = (): DigipostEntryPoint => {
  const entrypointContext = useContext(EntrypointContext);

  if (!entrypointContext) {
    throw new Error("context ikke satt");
  }

  return entrypointContext;
};

export const EntrypointContextProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const entrypoint = useLoaderData<DigipostEntryPoint>();

  if (entrypoint === null) {
    return <DelayedSpinner />;
  }

  return <EntrypointContext value={entrypoint}>{children}</EntrypointContext>;
};
